import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetNogaBranchesForEdition, SaveNogaBranchesForEdition };

function GetNogaBranchesForEdition(
  contractId,
  VersionId,
  editionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${VersionId}/editions/${editionId}/noga`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveNogaBranchesForEdition(
  contractId,
  VersionId,
  editionId,
  nogaBranches,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${VersionId}/editions/${editionId}/noga`,
      nogaBranches,
      headers,
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}
